import './activeMaintenance.scss';
import React, { Component } from 'react';
import moment from 'moment';

import { getMaintenanceSatusInfo } from '../../../helpers/componentHelper';

import maintenaceStatus from '../../../enums/maintenaceStatus';

class ActiveMaintenance extends Component {
  render() {
    const { maintenance } = this.props;
    const statusInfo = getMaintenanceSatusInfo(maintenance.status);
    return (
      <div className="maintenance">
        <div className="maintenance-info">
          <div>
            <i className="ion-settings maintenance-icon" />  
            <div className="maintenance-title">
              <span>{maintenance.name}</span>
            </div>
          </div>
        </div>
        <div style={{marginLeft: '25px'}}>{maintenance.description}</div>
        <div className="maintenance-status">
           <strong>{statusInfo.description + ' '}</strong>
           {maintenance.status === maintenaceStatus.scheduled.id ?
           <div style={{display: 'inline-block'}}>
              <span>at </span>
              <span className="info-data">{ moment(maintenance.startDate).format('MM/DD/YYYY h:mm A')}</span>
           </div>
           : null
           }
        </div>
        <div className="maintenance-services">
            <span className="info-label">Affected services: </span>
            {maintenance.components.map((c, i) => <span key={i} className="service">{c.name}</span>)}
        </div>
      </div>
    );
  }
}

export default ActiveMaintenance;